// extracted by mini-css-extract-plugin
export default {"services":"_services_services__+FyCQ","headphonesIcon":"_services_headphonesIcon__YqgIo"};